
import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

// Basic selectors
export const selectAllFolders = (state: RootState) => state.folder.items;
export const selectCurrentFolderId = (state: RootState) => state.folder.currentFolderId;
export const selectFolderLoading = (state: RootState) => state.folder.loading;
export const selectFolderError = (state: RootState) => state.folder.error;
export const selectSelectedFolderIds = (state: RootState) => state.folder.selectedFolderIds;

// Derived selectors
export const selectCurrentFolder = createSelector(
  [selectAllFolders, selectCurrentFolderId],
  (folders, currentFolderId) => 
    folders.find(folder => folder.id === currentFolderId)
);

export const selectChildFolders = createSelector(
  [selectAllFolders, (_, parentId: string | null) => parentId],
  (folders, parentId) => 
    folders.filter(folder => folder.parentId === parentId)
);

// Utility selectors
export const selectTopLevelFolders = createSelector(
  [selectAllFolders],
  (folders) => 
    folders.filter(folder => folder.parentId === null && folder.id !== 'all')
);

export const selectFolderBreadcrumb = createSelector(
  [selectAllFolders, selectCurrentFolderId],
  (folders, currentFolderId) => {
    const breadcrumb = [];
    let current = folders.find(f => f.id === currentFolderId);
    
    // If we're on 'all' or no folder is selected, return empty breadcrumb
    if (!current || current.id === 'all') {
      return [];
    }
    
    // Add current folder
    breadcrumb.unshift(current);
    
    // Add parent folders
    while (current && current.parentId) {
      const parent = folders.find(f => f.id === current.parentId);
      if (parent) {
        breadcrumb.unshift(parent);
        current = parent;
      } else {
        break;
      }
    }
    
    return breadcrumb;
  }
);
